import googleMapLoader from "./google-maps";
import $ from "./jquery";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { jsTemplate } from "./micro-templates";

// const width = $(window).width() < 768 ? 250 : 360;
const width = 360;

// const iconImg =
//   "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPC9zdmc+Cg==";
// const iconImgCluster =
//   "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiIGZpbGw9IiM5NTc4MzYiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";

class UnitsMap {
  #initialized = false;
  #$main;
  #$units;

  #isOpen = false;
  #zoom = 14;
  #properties;
  #map;
  #markers = [];
  #bounds;
  #activeInfoWindow;
  #markerCluster;

  #propertiesOther;
  #markersOther = [];
  #markerClusterOther;

  iconImg =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPC9zdmc+Cg==";
  iconImgCluster =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiIGZpbGw9IiM5NTc4MzYiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";

  iconImgOther =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPC9zdmc+Cg==";
  iconImgClusterOther =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMTYiIGZpbGw9IiM5NTc4MzYiLz4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiIGZpbGw9IiM5NTc4MzYiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";

  iconImgMixed =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiIGZpbGw9IiMxMzJENEYiIGZpbGwtb3BhY2l0eT0iMC44Ii8+CjxjaXJjbGUgY3g9IjIyIiBjeT0iMjIiIHI9IjE2IiBmaWxsPSIjRTE3QTVBIi8+Cjwvc3ZnPgo=";

  constructor($main, $units) {
    this.#$main = $main;
    this.#$units = $units;
    this.#properties = this.#$main.data("properties") ?? [];

    this.#propertiesOther = this.#$main.data("properties-other") ?? [];

    // -- custom icons
    if (this.#$main.data("icon")) {
      this.iconImg = this.#$main.data("icon");
    }

    if (this.#$main.data("icon-cluster")) {
      this.iconImgCluster = this.#$main.data("icon-cluster");
    }

    if (this.#$main.data("icon-other")) {
      this.iconImgOther = this.#$main.data("icon-other");
    }

    if (this.#$main.data("icon-cluster-other")) {
      this.iconImgClusterOther = this.#$main.data("icon-cluster-other");
    }

    this.#initmap();

    // listener.
    this.#listener();
  }

  getMap() {
    return this.#map;
  }

  open() {
    this.#$main.addClass("open");
    this.#$units.addClass("estatetool-units--open-map");

    if (this.#map) {
      this.#map.setOptions({
        zoomControl: true,
      });
    }

    this.#fitBounds();
    this.#isOpen = true;

    this.#adjustHeight();
  }

  close() {
    this.#$main.removeClass("open");
    this.#$units.removeClass("estatetool-units--open-map");

    if (this.#map) {
      this.#map.setOptions({
        zoomControl: false,
      });
    }

    if (this.#activeInfoWindow) {
      this.#activeInfoWindow.close();
    }

    this.#fitBounds();
    this.#isOpen = false;
  }

  async #initmap() {
    if (this.#initialized) {
      return;
    }

    const { Map } = await googleMapLoader.importLibrary("maps");

    if (!Map) {
      return;
    }

    const $mapContainer = $(".estl-units-map__map");
    if ($mapContainer.length < 0) {
      return;
    }

    const center = {
      lat: 56.2639,
      lng: 9.5018,
    };

    this.#map = new Map($mapContainer[0], {
      center: center,
      zoom: this.#zoom,
      fullscreenControl: false,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
    });

    this.#initMarkerClusters();

    this.#renderMarkers();

    this.#initialized = true;
  }

  async #initMarkerClusters() {
    const { Marker } = await googleMapLoader.importLibrary("marker");
    const { Size } = await googleMapLoader.importLibrary("core");

    this.#markerCluster = new MarkerClusterer({
      map: this.#map,
      renderer: {
        render: (cluster, _) => {
          let icon = this.iconImgCluster;

          // if cluster markers are mixed
          if (cluster?.markers?.some((m) => m?.property === "other")) {
            icon = this.iconImgMixed;
          }

          // if cluster markers are other only
          if (cluster?.markers?.every((m) => m?.property === "other")) {
            icon = this.iconImgClusterOther;
          }

          return new Marker({
            position: cluster._position,
            zIndex: 2,
            icon: {
              url: icon,
              scaledSize: new Size(44, 44),
            },
            label: {
              text: String(cluster?.count),
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: "700",
            },
          });
        },
      },
    });

    this.#markerClusterOther = new MarkerClusterer({
      map: this.#map,
      renderer: {
        render: (cluster, _) => {
          return new Marker({
            position: cluster._position,
            zIndex: 1,
            icon: {
              url: this.iconImgClusterOther,
              scaledSize: new Size(44, 44),
            },
            label: {
              text: String(cluster?.count),
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: "700",
            },
          });
        },
      },
    });
  }

  async #renderMarkers() {
    if (!this.#map) {
      return;
    }

    const { Marker } = await googleMapLoader.importLibrary("marker");
    const { LatLngBounds, Size, Point } = await googleMapLoader.importLibrary(
      "core"
    );

    // remove current markers
    this.#markers.forEach((marker) => {
      marker.setMap(null);
    });

    // init bounds
    this.#bounds = new LatLngBounds();

    let icon = {
      url: this.iconImg,
      scaledSize: new Size(32, 32),
      origin: new Point(0, 0),
      anchor: new Point(0, 0),
    };

    this.#properties.forEach((property) => {
      const [lat, lng] = property?.geocode
        ?.split(",")
        .map((v) => parseFloat(v));

      if (!lat || !lng) {
        return;
      }

      const location = {
        lat,
        lng,
      };

      const marker = new Marker({
        position: location,
        map: this.#map,
        icon,
        zIndex: 10,
        property: "main",
        label: {
          text: "1",
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "700",
        },
      });

      this.#markers.push(marker);

      this.#setInfoWindow(marker, property);

      this.#bounds.extend(marker.position);
    });

    this.#markerCluster.addMarkers(this.#markers);

    // -- other properties
    this.#propertiesOther.forEach((property) => {
      const [lat, lng] = property?.geocode
        ?.split(",")
        .map((v) => parseFloat(v));

      if (!lat || !lng) {
        return;
      }

      const location = {
        lat,
        lng,
      };

      const marker = new Marker({
        position: location,
        map: this.#map,
        property: "other",
        icon: {
          url: this.iconImgOther,
          scaledSize: new Size(32, 32),
          origin: new Point(0, 0),
          anchor: new Point(0, 0),
        },
        label: {
          text: "1",
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "700",
        },
      });

      this.#markersOther.push(marker);

      this.#setInfoWindow(marker, property, true);

      this.#bounds.extend(marker.position);
    });

    // this.#markerClusterOther.addMarkers(this.#markersOther);
    this.#markerCluster.addMarkers(this.#markersOther);

    this.#renderMarkersOffices();

    this.#fitBounds();
  }

  async #setInfoWindow(marker, property, otherVersion = false) {
    const { InfoWindow } = await googleMapLoader.importLibrary("maps");

    const contentString = jsTemplate($("#estl_tmpl_map_info_property").html(), {
      item: property,
      other: otherVersion,
    });

    let houseInfo = new InfoWindow({
      content: contentString,
      minWidth: width,
      maxWidth: width,
    });

    marker.addListener("click", () => {
      if (this.#activeInfoWindow) {
        this.#activeInfoWindow.close();
      }

      if (!this.#isOpen) {
        return;
      }

      houseInfo.open({
        anchor: marker,
        map: this.#map,
      });

      this.#activeInfoWindow = houseInfo;
    });
  }

  async #renderMarkersOffices() {
    const { Marker } = await googleMapLoader.importLibrary("marker");

    const offices = this.#$main.data("offices");

    if (!offices) {
      return;
    }

    offices?.items.forEach((office) => {
      const [lat, lng] = office?.position?.split(",").map((v) => parseFloat(v));

      if (!lat || !lng) {
        return;
      }

      const position = {
        lat,
        lng,
      };

      const marker = new Marker({
        position,
        map: this.#map,
        icon: offices.icon
          ? {
              url: offices.icon,
              scaledSize: new google.maps.Size(32, 32),
            }
          : undefined,
      });

      this.#bounds.extend(marker.position);

      this.#setInfoWindowOffices(marker, office);
    });
  }

  async #setInfoWindowOffices(marker, office) {
    const { InfoWindow } = await googleMapLoader.importLibrary("maps");

    const contentString = `
      <div class='estl-map-info'>
          <div class="estl-map-info__content">
              <div class="estl-map-info__title">${office.name}</div>
              <div class="estl-map-info__desc">${office.address}</div>
          </div>
      </div>
      `;

    let houseInfo = new InfoWindow({
      content: contentString,
      minWidth: width,
      maxWidth: width,
    });

    marker.addListener("click", () => {
      if (this.#activeInfoWindow) {
        this.#activeInfoWindow.close();
      }

      if (!this.#isOpen) {
        return;
      }

      houseInfo.open({
        anchor: marker,
        map: this.#map,
      });

      this.#activeInfoWindow = houseInfo;
    });
  }

  #fitBounds() {
    if (this.#map && this.#bounds && !this.#bounds.isEmpty()) {
      this.#map.fitBounds(this.#bounds);
      setTimeout(() => {
        if (this.#map.getZoom() > this.#zoom) {
          this.#map.setZoom(this.#zoom);
        }
      }, 500);
    }
  }

  #applyProperties(ids) {
    this.close();

    // trigger event
    const data = {
      propertyIds: ids
        .toString()
        .split(",")
        .map((id) => parseInt(id)),
    };

    this.#$units.trigger("estl:units_map:select_properties", data);
  }

  #listener() {
    const _this = this;

    $(".estl-units-map__open", this.#$main).on("click", function (ev) {
      ev.preventDefault();
      _this.open();
    });

    $(".estl-units-map__close", this.#$main).on("click", function (ev) {
      ev.preventDefault();
      _this.close();
    });

    // apply properties.
    this.#$main.on(
      "click",
      ".js-estl-unit-map-apply_properties",
      function (ev) {
        ev.preventDefault();

        _this.#applyProperties($(this).data("property-id"));
      }
    );

    // auto height on mobile
    $(window).on("resize", function () {
      _this.#adjustHeight();
    });
  }

  #adjustHeight() {
    this.#$main.height($(window).outerHeight());
  }
}

$(function () {
  // init.
  function init() {
    $(".js-flbestl-units-map").each(function () {
      const $units = $(this).closest(".estatetool-units");
      if ($units.length > 0) {
        if (!$(this).data("units-map")) {
          const map = new UnitsMap($(this), $units);
          $(this).data("units-map", map);
        }
      }
    });
  }

  if ($(".js-flbestl-units-map").length) {
    init();
  } else {
    // handle trigger, used for lazyload
    $(".js-estl-units").on("estl:units:init", init);
  }
});
